module.exports = __webpack_public_path__ + "img/143.0689be19.gif";